import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1519f9e8&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DesktopNavigation: require('/srv/rir-platform/tourism/src/tourism-front/components/common/DesktopNavigation/index.vue').default,MobileNavigation: require('/srv/rir-platform/tourism/src/tourism-front/components/common/MobileNavigation/index.vue').default,Header: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Header/index.vue').default})
